import { BaseProps } from "global";

export function TextOnlyMessage(props: BaseProps) {
  const { children } = props;
  return (
    <div className="w-fit min-w-0">
      <div className="max-w-full break-words rounded-xl bg-surface px-4 py-2.5 text-sm text-dark">
        {children}
      </div>
    </div>
  );
}
